import Loader from '@root/components/Loader';
import React, { lazy, Suspense, useRef } from 'react';
import IdleTimer from 'react-idle-timer';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
  useLocation,
  useHistory,
} from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';

const Dashboard = lazy(() => import('@root/containers/App'));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@root/containers/Pages/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import('@root/containers/Pages/404/404')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@root/containers/Pages/500/500')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@root/containers/Pages/SignIn')),
  },
];

function PrivateRoute({ children, ...rest }) {
  const location = useLocation();
  const { accessToken } = useSelector((state) => state.AuthCredentials.credentials);
  const idleTimer = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const onIdle = (e) => {
    console.log('user is idle', e);
    dispatch({ type: 'DATA_USER_LOGOUT' });
    history.push('/');
  };

  if (accessToken !== null)
    return (
      <>
        <IdleTimer
          ref={idleTimer}
          element={document}
          onActive={() => {}}
          onIdle={onIdle}
          onAction={() => {}}
          debounce={250}
          timeout={172800000}
        />
        <Route {...rest}>{children}</Route>
      </>
    );

  return (
    <Redirect
      to={{
        pathname: '/signin',
        state: { from: location },
      }}
    />
  );
}
export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            <PrivateRoute path="/app">
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
